import React, { useEffect } from 'react';
import { Grid } from '@mui/material';

import Banner from '../../components/banner';
import Enrich from '../../components/enrich';
import FootPrint from '../../components/footprint';
import Leading from '../../components/leading';
import GetKnow from '../../components/getKnow';
import GetusKnow from '../../components/getus';
import Clients from '../../components/clients';
import { Helmet } from 'react-helmet';

const Home = () => {

    
      const faqSchema6 = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "What makes Unique Engineers a reliable MEP contractor in India?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We take full responsibility from planning to handover. No service is outsourced. No scope is loosely defined. Every part of your system is accounted for and delivered with precision."
        }
      },{
        "@type": "Question",
        "name": "How do you ensure project timelines are met?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We operate with in-house teams and tightly controlled schedules. Our planning approach ensures minimum overlap and maximum progress."
        }
      },{
        "@type": "Question",
        "name": "Do you offer MEP services across India?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Our operations span across industrial and commercial hubs throughout India, adapting to local regulations and project conditions."
        }
      },{
        "@type": "Question",
        "name": "Can you handle high-scale industrial HVAC installations?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. Our HVAC team has delivered cleanroom-compliant and large-volume cooling systems for manufacturing, pharma and data centres."
        }
      },{
        "@type": "Question",
        "name": "What sectors do you typically serve?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We serve industrial, commercial, healthcare, warehousing, and mixed-use developments. Our systems are scalable and tailored to sector-specific needs."
        }
      }]
    
        };

    useEffect(() => {
        window.scrollTo({top:0, left:0})
    }, [])


    return (
        <Grid container style={{width:'100%', justifyContent:'center'}}>

<Helmet>
<title>MEP Company in India | MEP Contractor and MEP Services – Unique Engineers</title>
<meta name="description" content="MEP company in India delivering reliable MEP services for industrial and commercial projects, backed by an experienced MEP contractor with end-to-end execution capability." />
<meta name="keywords" content="MEP Engineering Services, MEP Consultants in gurgaon, Mep Services in Gurgaon" />
<link rel="canonical" href="https://www.uniqueengineersltd.com/" />      
      
   <script type="application/ld+json">
                    {JSON.stringify(faqSchema6)}
                </script>   
      </Helmet>

            <Grid item xs={12} sx={{width:'100'}} >
            <Grid style={{backgroundColor:'#F4F8FA', width:'100%', display:'flex', justifyContent:'center'}}>
                <Banner />
            </Grid>
            <Enrich />
            <FootPrint title='Our footprint' content='At Unique Engineers, we believe buildings should not just serve today’s needs, they should be ready for tomorrow. That is why our solutions focus on long-term performance. We use smart controls, efficient layouts, and high-quality materials that stand the test of time.
Being one of the top MEP consultants in Gurgaon means staying current with new technologies and evolving standards. We are always learning. And we bring that knowledge to every project.' />
            <Leading />
            <GetKnow />
            <GetusKnow />
            <Clients />
        </Grid>
        </Grid>
    )

}

export default Home;